import { useFeatureGate } from '@statsig/react-bindings';
import { useCallback } from 'react';

import { useVideoPlatform, useVideoPlatformCallback } from '../../../hooks/useVideoPlatform';
import { Statsig } from '../../../statsig/StatsigProvider';
import { telehealthRejoinRoomGate } from '../../../statsig/gates';

/**
 * Use this to check whether to show the rejoin flow and reconnecting indicators
 * for Zoom. The Zoom check is just extra guard to limit blast radius, and this
 * feature should work for Twilio as well. If enabled for Twilio, then Twilio
 * users should see reconnection indicators as expected, but they won't see a
 * manual way to rejoin while in a session (that's behavior that's [exclusive
 * to
 * Zoom](https://devforum.zoom.us/t/how-to-handle-internet-disconnection-properly/65018)).
 */
export function useIsRejoinEnabled() {
  const { value: isRejoinEnabled } = useFeatureGate(telehealthRejoinRoomGate);
  const videoPlatform = useVideoPlatform();
  const getVideoPlatform = useVideoPlatformCallback();

  const checkRejoinIsEnabled = useCallback(
    () => getVideoPlatform() === 'zoom' && Statsig.checkGate(telehealthRejoinRoomGate),
    [getVideoPlatform],
  );

  return [videoPlatform === 'zoom' && isRejoinEnabled, checkRejoinIsEnabled] as const;
}
